import styled from 'styled-components';

export const TitleWrapper = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ChildrenWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  overflow: hidden;
`;
